import React, { useEffect, useState } from "react";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import { assetTypes, STEP_GROUP_IDS } from "../../../../shared/config";
import { ownershipTypesConfig } from "../config";
import AdditionalDataCupsNumberForm from "./steps/AdditionalDataCupsNumberForm";
import AdditionalDataFamilyForm from "./steps/AdditionalDataFamilyForm";
import AdditionalDataPropertyTypeForm from "./steps/AdditionalDataPropertyTypeForm";
import AdditionalDataResidenceForm from "./steps/AdditionalDataResidenceForm";
import NieEuAdditionalData from "../NieEuAdditionalData/NieEuAdditionalData";
import { AutocompleteAdditionalDataAddress } from "./steps/AutocompleteAdditionalDataAddress/AutocompleteAdditionalDataAddress";
import AdditionalDataAddressComplement from "./steps/AdditionalDataAddressComplement/AdditionalDataAddressComplement";

export default function AdditionalData({
  showNieEuFunc,
  currentModuleStepHandler,
  disableMaritalRegime,
  disableOthers,
}) {
  const FORM_NAMES = {
    NIE_EU_ADDITIONAL_DATA: "NIE_EU_ADDITIONAL_DATA",
    BIRTH_INFO_NIE_EU: "BIRTH_INFO_NIE_EU",
    DOC_ID_PICTURE_NIE_EU: "DOC_ID_PICTURE_NIE_EU",
    ADDRESS_DATA_FORM: "ADDRESS_DATA_FORM",
    ADDRESS_DATA_COMPLEMENT_FORM: "ADDRESS_DATA_COMPLEMENT_FORM",
    RESIDENCE_DATA_FORM: "RESIDENCE_DATA_FORM",
    PROPERTY_TYPE_DATA_FORM: "PROPERTY_TYPE_DATA_FORM",
    UTILITIES_SUPPLY_CUPS_NUMBER: "UTILITIES_SUPPLY_CUPS_NUMBER",
    HOME_IMPROVEMENT_ADDRESS_GROUP: "HOME_IMPROVEMENT_ADDRESS_GROUP",
    FAMILIAR_DATA_FORM: "FAMILIAR_DATA_FORM",
  };

  const {
    state: { loan, asset, participant },
    dispatch,
  } = React.useContext(ProcessContext);

  const [assetRequired, setAssetRequired] = useState(undefined);

  const { submitStep, manageGroup, getStepData } = currentModuleStepHandler;

  useEffect(() => {
    if (loan.asset_reference[0].type === assetTypes.UTILITIES_SUPPLY) {
      setAssetRequired(true);
      dispatch({
        type: "REQUEST_GET_ASSET_DETAILS",
        payload: {
          assetId: loan.asset_reference[0].id,
          assetType: loan.asset_reference[0].type,
        },
      });
    } else {
      setAssetRequired(false);
    }
  }, []);

  const STEP_GROUP_STEPS_ARRAY = [
    {
      id: FORM_NAMES.NIE_EU_ADDITIONAL_DATA,
      show: showNieEuFunc,
      isGroup: true,
    },
    {
      id: FORM_NAMES.ADDRESS_DATA_FORM,
      show: () => true,
    },
    {
      id: FORM_NAMES.ADDRESS_DATA_COMPLEMENT_FORM,
      show: () => true,
    },
    {
      id: FORM_NAMES.RESIDENCE_DATA_FORM,
      show: () => true,
    },
    {
      id: FORM_NAMES.PROPERTY_TYPE_DATA_FORM,
      show: (allStepValues) =>
        allStepValues[FORM_NAMES.RESIDENCE_DATA_FORM].ownershipType ===
        ownershipTypesConfig.OWNERSHIP.value,
    },
    {
      id: FORM_NAMES.UTILITIES_SUPPLY_CUPS_NUMBER,
      show: () =>
        loan.asset_reference[0].type === assetTypes.UTILITIES_SUPPLY &&
        asset?.cups === null,
    },
    {
      id: FORM_NAMES.FAMILIAR_DATA_FORM,
      show: () => true,
    },
  ];

  const CURRENT_STEP_GROUP = STEP_GROUP_IDS.AdditionalData;

  const stepGroupStepToShow =
    (asset || assetRequired === false) &&
    manageGroup(CURRENT_STEP_GROUP, STEP_GROUP_STEPS_ARRAY);

  return (
    <>
      {stepGroupStepToShow === FORM_NAMES.NIE_EU_ADDITIONAL_DATA && (
        <NieEuAdditionalData
          participant={participant}
          currentModuleStepHandler={currentModuleStepHandler}
        />
      )}
      {stepGroupStepToShow === FORM_NAMES.ADDRESS_DATA_FORM && (
        <AutocompleteAdditionalDataAddress
          onSubmitForm={submitStep}
          data={getStepData()}
        />
      )}
      {stepGroupStepToShow === FORM_NAMES.ADDRESS_DATA_COMPLEMENT_FORM && (
        <AdditionalDataAddressComplement
          onSubmitForm={submitStep}
          data={getStepData()}
        />
      )}
      {stepGroupStepToShow === FORM_NAMES.RESIDENCE_DATA_FORM && (
        <AdditionalDataResidenceForm
          onSubmitForm={submitStep}
          data={getStepData()}
          disableOthers={disableOthers}
        />
      )}
      {stepGroupStepToShow === FORM_NAMES.PROPERTY_TYPE_DATA_FORM && (
        <AdditionalDataPropertyTypeForm
          onSubmitForm={submitStep}
          data={getStepData()}
          disableOthers={disableOthers}
        />
      )}
      {stepGroupStepToShow === FORM_NAMES.UTILITIES_SUPPLY_CUPS_NUMBER && (
        <AdditionalDataCupsNumberForm
          onSubmitForm={submitStep}
          data={getStepData()}
        />
      )}
      {stepGroupStepToShow === FORM_NAMES.FAMILIAR_DATA_FORM && (
        <AdditionalDataFamilyForm
          onSubmitForm={submitStep}
          data={getStepData()}
          disableMaritalRegime={disableMaritalRegime}
        />
      )}
    </>
  );
}
